import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Unknown", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Unknown", -1)
const _hoisted_7 = { class: "flex flex-col justify-center gap-3 flex-wrap" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Help = _resolveComponent("Help")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FieldList = _resolveComponent("FieldList")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    onMouseenter: _ctx.handleHighlight,
    onFocus: _ctx.handleHighlight,
    class: "p-2 border-current grid grid-cols-2 gap-2 hover:bg-blue-100 focus:bg-blue-100"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_FieldList, { class: "gap-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_Field, {
            display: "above",
            name: "Block"
          }, {
            default: _withCtx(() => [
              (_ctx.block)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.block), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_Help, { help: "We may display unknown values because this segment has no associated postal addresses." }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_Field, {
            display: "above",
            name: "Roadway width"
          }, {
            default: _withCtx(() => [
              (_ctx.width)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.width) + " feet", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_Help, { help: "We may display unknown values because the City of Portland\n                    does not manage this specific street segment." }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.crossSectionRoute && !_ctx.street.oneWay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: _ctx.crossSectionRoute,
                class: "border-b-2 border-current text-sm font-medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("View cross sections")
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: `/streets/${_ctx.id}`,
            class: "border-b-2 border-current text-sm font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View segment details")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onMouseenter", "onFocus"]))
}